// 11 §14 colour modes for the intent layer: four intent colours + grey declarations + flags.
import type { ColourMode } from '../../core/stores/settings';
import { STATUS_INFO } from '../../core/sim/statuses';

export interface IntentPalette {
  move: number; attack: number; area: number; support: number;
  declaration: number; red: number; amber: number; hint: number;
  badgeBg: number; badgeText: string; text: string; hpLost: number; hpKeep: number; hpBg: number;
  strokeWidth: number;
}

const base: IntentPalette = {
  move: 0x5aa9ff, attack: 0xff4d4d, area: 0xffa033, support: 0x4ccf6a,
  declaration: 0xa5aab5, red: 0xff3b3b, amber: 0xffbf3b, hint: 0xd7a5ff,
  badgeBg: 0x0b1020, badgeText: '#ffffff', text: '#f3f4f6', hpLost: 0xff6b6b, hpKeep: 0x5be37c, hpBg: 0x2a2f3a,
  strokeWidth: 1,
};

export const PALETTES: Record<ColourMode, IntentPalette> = {
  default: base,
  deuteranopia: { ...base, move: 0x3d85ff, attack: 0xff8c1a, area: 0xffe14d, support: 0xb080ff },
  protanopia: { ...base, move: 0x3d85ff, attack: 0xff8c1a, area: 0xffe14d, support: 0xb080ff },
  tritanopia: { ...base, move: 0xff5a5a, attack: 0x2ec4c4, area: 0xffd34d, support: 0xb080ff },
  highContrast: { ...base, move: 0xffffff, attack: 0xffffff, area: 0xffffff, support: 0xffffff, declaration: 0xbbbbbb, badgeBg: 0x000000, strokeWidth: 2 },
};

/** A hero's mark on its badges. No star among them: ★ marks a planned bonus action (docs/81 SA7). */
export const SHAPE_MARKS = ['●', '▲', '■', '◆', '▼', '✚', '✕', '⬟', '⬢', '◉', '◐', '♦'];
export const STATUS_ABBR: Record<string, string> = Object.fromEntries(Object.entries(STATUS_INFO).map(([k, v]) => [k, v.abbr]));
export const hex = (n: number): string => `#${n.toString(16).padStart(6, '0')}`;

/** docs/81 SA6: the attack plan line's width and arrowhead size for a square of `px` (thick enough to read at any zoom). */
export function attackStroke(px: number, base: number): { width: number; head: number } {
  const width = Math.max(3, Math.round(px * 0.09)) + base;
  return { width, head: Math.max(8, Math.round(px * 0.25)) + width };
}
